/* eslint-disable import/prefer-default-export */
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getParcelAccountDetails } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetParcelAccountDetails(id: number, options?: UseQueryOptions) {
  return useQuery({
    queryKey: userQueryKeys.parcelAccountDetails(id),
    queryFn: () => getParcelAccountDetails(id).then((res) => res.data),
    ...options,
  });
}
